// extracted by mini-css-extract-plugin
export default {"backIcon":"AdminMobileCateRegister_backIcon__1ooPp","regiBtn":"AdminMobileCateRegister_regiBtn__H1eNO"};